import { render, staticRenderFns } from "./CustomeTable.vue?vue&type=template&id=03c8479a"
import script from "./CustomeTable.vue?vue&type=script&lang=js"
export * from "./CustomeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports